import { useState, useEffect } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useAdmin } from '../../contexts/AdminContext'
import { useUsers } from '../../contexts/UsersContext'
import DetailsPage from '../personal/DetailsPage'

const Summary = () => {
  const { loggedOnUser } = useUsers()
  const { myQuotes, messages } = useAdmin()
  const [showDetails, setShowDetails] = useState(false)
  const [type, setType] = useState('')
  const [element, setElement] = useState({})
  useEffect(() => {}, [])

  return (
    <>
      {loggedOnUser && (
        <Container>
          <Row className='member-statistical'>
            <Col sm={3}>
              <div className='item blue' style={{ height: '150px' }}>
                <h3>Manage my Account</h3>
                <span className=''>Name: {loggedOnUser.name}</span>
                <br />
                <span className=''>Email:{loggedOnUser.email} </span>
                <br />
                <span className=''>
                  PostCode:
                  {loggedOnUser.postcode
                    ? loggedOnUser.postcode
                    : 'Address Incomplete'}
                </span>
                <Button onClick={() => alert('Edit Account')}>Change</Button>
              </div>
            </Col>
            <Col sm={3}>
              <div className='item green' style={{ height: '150px' }}>
                <h3>Jobs Posted by me</h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setType('created order')
                    setElement(myQuotes)
                    setShowDetails(true)
                  }}
                >
                  {myQuotes && myQuotes.length > 0 ? myQuotes.length : 0}
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>{' '}
            <Col sm={3}>
              <div className='item yellow' style={{ height: '150px' }}>
                <h3>Quotes received</h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setType('quote')
                    setElement(
                      messages &&
                        messages.filter(
                          (message) =>
                            message.to === loggedOnUser.email &&
                            message.type === 'quote'
                        )
                    )
                    setShowDetails(true)
                  }}
                >
                  {messages &&
                    messages.length > 0 &&
                    messages.filter(
                      (message) =>
                        message.to === loggedOnUser.email &&
                        message.type === 'quote'
                    ).length}
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>{' '}
            <Col sm={3}>
              <div className='item purple' style={{ height: '150px' }}>
                <h3>Messages Received </h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setType('message')
                    setElement(
                      messages &&
                        messages.filter(
                          (message) =>
                            message.to === loggedOnUser.email &&
                            message.type === 'moreInfo'
                        )
                    )
                    setShowDetails(true)
                  }}
                >
                  {messages &&
                    messages.length > 0 &&
                    messages.filter(
                      (message) =>
                        message.to === loggedOnUser.email &&
                        message.type === 'moreInfo'
                    ).length}
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>
          </Row>
          <Row className='member-statistical'>
            {' '}
            <Col sm={3}>
              <div className='item purple' style={{ height: '150px' }}>
                <h3>Orders in Progress </h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setType('orders in progres')
                    setElement(
                      myQuotes &&
                        myQuotes.filter((quote) => quote.status !== 'New')
                    )
                    setShowDetails(true)
                  }}
                >
                  {myQuotes &&
                    myQuotes.length > 0 &&
                    myQuotes.filter((quote) => quote.status !== 'New').length}
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>
            <Col sm={3}>
              <div className='item purple' style={{ height: '150px' }}>
                <h3>Orders Completed </h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => console.log('On the way')}
                >
                  {myQuotes &&
                    myQuotes.length > 0 &&
                    myQuotes.filter((quote) => quote.status === 'Completed')
                      .length}
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>
            <Col sm={3}>
              <div className='item purple' style={{ height: '150px' }}>
                <h3>Invoices </h3>
                <span
                  className='number'
                  style={{ cursor: 'pointer' }}
                  onClick={() => alert('This section is not yet available')}
                >
                  0
                </span>{' '}
                <span className='line'></span>
              </div>
            </Col>
          </Row>
        </Container>
      )}
      {showDetails && <DetailsPage type={type} element={element} />}
    </>
  )
}

export default Summary
